import { getEnvironment } from '@toloka-tb/common/utils/environment';

import { getDefaultAuthToken, getMondaySubitemId, setAuthTokenHook } from '../utils';
import { sendTbApiRequest } from '../utils/sendTbApiRequest';

const USER_LOGS_URL = 'https://api-ui.toloka.ai/api/user-logs/typed';

export const sendEvent = async (type: string, payload: Record<string, unknown>) => {
    try {
        const mondayId = getMondaySubitemId() || 0;
        const projectId = 'unknown';

        const data = {
            type: `tb_${type}`,
            value: {
                monday_id: mondayId,
                project_id: projectId,
                ...payload
            }
        };

        if (getEnvironment() !== 'prod') {
            console.log('USER_LOG', data);

            return;
        }

        await sendTbApiRequest({
            endpointName: 'user-logs.send-event',
            url: USER_LOGS_URL,
            method: 'POST',
            credentials: 'include',
            json: data,
            retry: {
                limit: 1,
                methods: ['get', 'post', 'head', 'options'],
                statusCodes: [401, 403]
            },
            hooks: {
                beforeRequest: [setAuthTokenHook],
                beforeRetry: [
                    ({ request }) => {
                        request.headers.set('Authorization', `ApiKey ${getDefaultAuthToken()}`);
                    }
                ]
            }
        });
    } catch (error) {
        console.error('Failed to send the user log', error);
    }
};
